module.exports = __webpack_public_path__ + "static/img/weather40.51e0c48f.png";